/**
 * A busca de chamados dos seletores de Mesclar e de Chamado relacionado.
 *
 * ## O que havia antes
 *
 * Os dois modais pré-carregavam a lista com `GET /ticket` SEM escopo — todos os
 * chamados já criados, 266 mil em produção, com as relações completas. O
 * processo do PHP morria, o `catch` esvaziava a lista, e abrir "Mesclar" não
 * mostrava chamado nenhum para escolher. Não era console feio: era a
 * funcionalidade sem funcionar, desde 01/10.
 *
 * ## Por que buscar no servidor é o certo, e não só o mais leve
 *
 * `/ticket/paginated` é o endpoint feito para isso e já é usado assim na própria
 * tela de chamados. E a busca dele alcança chamado **fechado** — exatamente o
 * caso de quem quer mesclar um duplicado antigo. O pré-carregamento, mesmo
 * funcionando, trazia só o que couber na memória.
 */

/** Menos que isto casaria com quase tudo, e custaria uma consulta por tecla. */
export const MIN_CARACTERES = 2;

/** Quantos candidatos por busca. Um seletor com mais que isso ninguém lê. */
export const POR_PAGINA = 50;

/**
 * Os parâmetros da busca, ou `null` quando não há o que buscar.
 *
 * `null` é a resposta para termo curto: quem chama limpa a lista em vez de
 * consultar o servidor.
 *
 * @param {string|null|undefined} termo
 */
export const paramsDaBusca = (termo) => {
    const limpo = String(termo ?? '').trim();

    if (limpo.length < MIN_CARACTERES) {
        return null;
    }

    return {
        search: limpo,
        per_page: POR_PAGINA,
        page: 1,
        sort_by: 'created_at',
        sort_dir: 'desc',
    };
};

/**
 * Os candidatos de uma resposta do `/ticket/paginated`.
 *
 * Duas exclusões:
 *
 * - **o próprio chamado**, que não pode ser mesclado consigo mesmo;
 * - **os já mesclados**, que não existem mais como chamado próprio — as listas
 *   os escondem por desenho, e oferecê-los levaria a mesclar com algo que já
 *   foi absorvido.
 *
 * @param {object|null} resposta corpo da resposta (`{data: [...]}`)
 * @param {number|string} idAtual o chamado aberto
 */
export const candidatosDaResposta = (resposta, idAtual) => {
    const lista = Array.isArray(resposta?.data) ? resposta.data : [];
    const atual = Number(idAtual);

    return lista.filter((t) => Number(t?.id) !== atual && !t?.merged_into_ticket_id);
};
